import RouteModel from "../../model-factory/basic/route/RouteModel";
import {FactoryID, RouteKey} from "../../model-factory/type-interface/ModelFactoryType";
import RouteFactory from "../../model-factory/basic/route/RouteFactory";
import RouteChoice from "../../model-factory/basic/route/RouteChoice";
import {IRouteIDs} from "../../model-factory/type-interface/ModelFactoryInterface";
import {PostStatus, PostType} from "../../manager/post/PostManager";
import {getManager} from "../../manager/Manager";
import {getModelFactory} from "../../model-factory/ModelFactory";

export class PostStatusRouteModel extends RouteModel
{

    navigationRouteKey: RouteKey = "post_status_route_id";
    choiceOrder = ["project", "offer"];

    postStatus:PostStatus = null!;

    applyModelConditions()
    {
        super.applyModelConditions();

        this.postStatus = this.populateIDs.post_status as PostStatus;
    }


    applyChoice(choice: RouteChoice)
    {
        if(this.postStatus === "expired"){
            choice.name = choice.name + " Archive"
        } else if(this.postStatus === "draft"){
            choice.name = "Unpublished "+choice.name
        } else if(this.postStatus === "pending"){
            choice.name = "Pending "+choice.name
        }
        super.applyChoice(choice);
    }

}

export default class PostStatusRouteFactory extends RouteFactory
{

    id: FactoryID = "post_status_route";

    constructor()
    {
        super();


        this.choices = {
            project: new RouteChoice({
                name: "Projects",
                nextFactoryID: "post_list_route",
                isSecondaryRoute: true,
                derivedRouteIDs: {
                    post_type: "project"
                }
            }),
            offer: new RouteChoice({
                name: "Offers",
                nextFactoryID: "post_list_route",
                isSecondaryRoute: true,
                derivedRouteIDs: {
                    post_type: "offer"
                }
            }),
        }
    }

    birth(id: FactoryID): PostStatusRouteModel
    {
        return new PostStatusRouteModel(id);
    }

    getDefaultModel(postStatus:PostStatus): PostStatusRouteModel | null
    {
        let postStatusBrowseRouteID = ""
        if(postStatus === "expired"){
            postStatusBrowseRouteID = "archive"
        } else if(postStatus === "draft"){
            postStatusBrowseRouteID = "unpublished"
        } else if(postStatus === "pending"){
            postStatusBrowseRouteID = "pending"
        }
        if(!postStatusBrowseRouteID){
            return null;
        }
        let routeIDs:IRouteIDs;

        routeIDs = {
            browse_route_id: postStatusBrowseRouteID
        }
        return this.getDefaultModelWithRoute(routeIDs)! as PostStatusRouteModel;
    }
}